import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import App from './App'; //import functionName from filename.js
import HomeApp from './homeapp'; //add this line
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

if(localStorage.getItem("adminid") !=null){
  root.render(
    <React.StrictMode>
      <App/>
    </React.StrictMode>
  );

}else{
  root.render(
    <React.StrictMode>
      <HomeApp/>
    </React.StrictMode>
  );
  
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
